export const initNavigation = function (config) {

  // Handle white background class, if first section element is iamge-hero
  if ($('main > section:first-of-type.flixx_hero.image').length > 0) {
    $('body').addClass('has-hero')
  }

  $('li.dropdown > a.nav-link div.toggle-nav').on('click', function (e) {
    e.preventDefault()
    let $parentLi = $(this).closest('li.dropdown');

    console.log($parentLi);

    if ($parentLi.children('a').hasClass('show')) {
      $parentLi.children('a').first().removeClass('show');
      $parentLi.children('div').first().removeClass('show');
    } else {
      $parentLi.children('a').first().addClass('show');
      $parentLi.children('div').first().addClass('show');
    }
  });

  //megamenu show column 2
  $('li.has-submenu > a.nav-link').on('click mouseover', function (e) {
    //e.preventDefault();
    let $submenuSource = $(this).siblings('div');
    let $submenuTarget = $(this).closest('.megamenu').find('.submenu-target-l2');
    $(this).closest('.megamenu').find('.submenu-target-l3').empty();
    $submenuTarget.html($submenuSource.html());
  });


  //megamenu show column 3
  let observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var newNodes = mutation.addedNodes; // DOM NodeList
      if (newNodes !== null) { // If there are new nodes added
        var $nodes = $(newNodes); // jQuery set
        $nodes.each(function () {
          $('a.nav-link', this).on('click mouseover', function (e) {
            //e.preventDefault();
            let $submenuSource = $(this).siblings('div');
            let $submenuTarget = $(this).closest('.megamenu').find('.submenu-target-l3');
            $submenuTarget.html($submenuSource.html());
          });
        });
      }
    });
  });

  $('.submenu-target-l2').each(function () {
    // Pass in the target node, as well as the observer options
    observer.observe($(this)[0], {
      attributes: true,
      childList: true,
      characterData: true
    });
  });
}
